import React from 'react'
import { CalendarOutlined, CheckSquareOutlined, DownOutlined, ToolOutlined } from '@ant-design/icons';
import { Dropdown, Space } from 'antd';
import { Link, useNavigate } from "react-router-dom";
import useProfileData from '../../hooks/useProfileData';

export default function DirectorNavbar() {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const { profileData } = useProfileData();
    const onClick = ({ key }) => {
        // message.info(`Click on item ${key}`);
        navigate(`/${key}`, { replace: true });
    };
    const navigate = useNavigate();

    const items = [
        {
            label: 'Activity Report',
            key: 'DailyActivityReport',
        },
        {
            label: "Employee",
            key: "HrEmployeeList"
        },
        {
            label: "Customer",
            key: "CustList"
        },
        {
            label: "Order Process",
            key: "OrderProcessDefault"
        },
        {
            label: "Order Analytics",
            key: "Analytics/Orders"
        },
        {
            label: "Targets Overview",
            key: "TargetsOverview"
        },
        {
            label: 'Employees Graph',
            key: 'Dar/EmployeesGraph'
        },
        {
            label: "Subordinates Leave History",
            key: "LeaveDetail/SubordinateLeaveHistory"
        }
    ];

    // const reviewAndPerformace = [
    //     {
    //         label: "Manager Audit",
    //         key: "Appraisal/ManagerAuditEmpList",
    //     },
    // ];

    return (
        <div className='dropdown-navbar d-flex gap-2 my-1'>
            <Dropdown
                menu={{
                    items,
                    onClick,
                }}
            >
                <a onClick={(e) => e.preventDefault()} style={{ color: "black", fontSize: '13px', fontWeight: 600 }}>
                    <Space>
                        <CalendarOutlined />Director Desk<DownOutlined />
                    </Space>
                </a>
            </Dropdown>
            {
                +profileData.loginId === 1 && (
                    <Link
                        to="/Appraisal/CeoReview" style={{ color: "black", fontSize: '13px', fontWeight: 600 }}
                    >
                        <Space>
                            <CalendarOutlined />CEO Review
                        </Space>
                    </Link>
                )
            }

            {
                userData.isReportingHead && (
                    <Link
                        to="/ResignationInfo/ReportingHeadList"
                        style={{
                            color: "black",
                            fontSize: "13px",
                            fontWeight: 600
                        }}
                    >
                        <Space>
                            <CheckSquareOutlined />
                            Resignation List
                        </Space>
                    </Link>
                )
            }

            {/* <Dropdown
                menu={{
                    items: reviewAndPerformace,
                    onClick,
                }}
            >
                <a
                    onClick={(e) => e.preventDefault()}
                    style={{
                        color: "black",
                        fontSize: "13px",
                        fontWeight: 600,
                        marginLeft: "0.75rem",
                    }}
                >
                    <Space>
                        <ToolOutlined />
                        Review
                        <DownOutlined />
                    </Space>
                </a>
            </Dropdown> */}
        </div>
    )
}